export const allowedDocumentMimeTypes = [
  "image/jpeg",
  "image/png",
  "image/heic",
  "image/heif",
  ".heic",
  "application/pdf",
];
export const MaxFileSize = 26214400;
